<template>
	<div class="server-container" v-loading="loading">
		<div class="box mainCont">
			<div class="item">
				<div class="label">
					<span>服务分类</span><i class="iconfont icon-right"></i>
				</div>
				<div class="classList">
					<span class="c_item" :class="productTypeId==''?'active':''" @click="getErList()">全部</span>
					<span class="c_item" :class="productTypeId==item.id?'active':''" v-for="(item,index) in listType" :key="index" @click="getErList(item)">{{item.typeName}}</span>
				</div>
			</div>
			<div class="item" v-if="listType2.length">
				<div class="label">
					<span>二级分类</span><i class="iconfont icon-right"></i>
				</div>
				<div class="classList">
					<span class="c_item" :class="productTypeId2==''?'active':''" @click="getErBtn()">全部</span>
					<span class="c_item" :class="productTypeId2==item.id?'active':''" @click="getErBtn(item)" v-for="(item,index) in listType2" :key="index">{{item.typeName}}</span>
				</div>
			</div>
		</div>
		<div class="list mainCont">
			<div class="item" v-for="(item,index) in list" :key="index" @click="goDetail(item)">
				<div class="img"><img :src="item.productImg" :alt="item.productName"></div>
				<div class="txt">
					<h3>{{item.productName}}</h3>
					<p class="text-ellipsis">{{item.misoshu}}</p>
				</div>
			</div>
		</div>
		<el-empty v-if="!loading&&list.length==0" description="暂无服务项目"></el-empty>
		
		<div class="pageBox">
			<el-pagination background layout="prev, pager, next" :page-size="pageSize" :hide-on-single-page="true" :total="total" @current-change="handleCurrentChange">
			</el-pagination>
		</div>
	</div>
</template>
<script >
	
import {getProductList,getProductTypeList} from '@/api/api'
export default {
	name: 'home2',
	data() {
		return {
			listType:[],//一级分类
			listType2:[],//二级分类
			list:[],
			productTypeId:'',//一级Id
			productTypeId2:'',//二级Id
			pageIndex:1,
			pageSize:15,
			total:0,
			loading:true,
		};
	},
	watch:{
		"$route":{
			handler(route){
				if(this.$route.query.id){
					this.productTypeId = this.$route.query.id;
					this.getErList({id:this.$route.query.id})
				}
				if(this.$route.query.idIn){
					this.productTypeId2 = this.$route.query.idIn
				}
			},
			deep:true,
		}
	},

	mounted() {
		if(this.$route.query.id){
			this.productTypeId = this.$route.query.id;
			this.getErList({id:this.$route.query.id})
		}
		if(this.$route.query.idIn){
			this.productTypeId2 = this.$route.query.idIn
		}
		
		this.getProductTypeList();
		this.getProductList();
	},
	methods: {
		// 一级分类
		getProductTypeList(){
			getProductTypeList({flType: "0"}).then(res => {
				this.listType = res.data;
			})
		},
		// 二级分类
		getErList(item){
			if(item){
				this.productTypeId = item.id;
				this.productTypeId2 = '';
				getProductTypeList({flType: "0",parentId:item.id}).then(res => {
					this.listType2 = res.data;
					this.pageIndex = 1;
					this.getProductList();
				})
			}else{
				this.productTypeId = '';
				this.productTypeId2 = '';
				this.pageIndex = 1;
				this.getProductList();
			}
			
		},
		// 二级--点击
		getErBtn(item){
			if(item){
				this.productTypeId2 = item.id;
				this.pageIndex = 1;
				this.getProductList();
			}else{
				this.productTypeId2 = '';
				this.pageIndex = 1;
				this.getProductList();
			}
		},
		getProductList(){
			this.loading = true;
			let pageIndex = this.pageIndex;
			let productTypeId = this.productTypeId2?this.productTypeId2:this.productTypeId;
			getProductList({pageIndex,pageSize:this.pageSize,city:this.city,productTypeId}).then(res => {
				let list = res.data;
				list.forEach(ele=>{
					if(ele.productImg){
						ele.productImg = ele.productImg.split(',')[0]
					}
				})
				this.total = res.total;
				this.list = list;
				this.loading = false;
			})
		},
		// 分页
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getProductList();
		},
		goDetail(item){
			this.$router.push({
			path: '/server/detail',
				query: {
					id: item.id
				}
			})
		},
	},
};
</script>
<style lang="scss" scoped>
.server-container{background-color: #F5F8F9;padding-top:24px;
	.box{background: #FFFFFF;border-radius: 8px;padding: 24px 24px 0;
		.item{display: flex;align-items: flex-start;
			.label{display: flex;align-items: center;justify-content: space-between;width: 92px;flex: 0 0 92px;line-height: 28px;
				color: #1F263F;font-size: 16px;
				i{color: #A4A9B7;font-size: 12px;}
			}
			.classList{display: flex;align-items: center;flex-wrap: wrap;margin-right: -26px;margin-left: 16px;
				&.bg{background-color: #F5F8F9;}
				.c_item{padding: 0 8px;line-height: 28px;height: 28px;border-radius: 4px;margin-right: 26px;color: #6B738B;font-size: 16px;margin-bottom: 12px;cursor: pointer;transition: all .3s;
					&.active,&:hover{background: rgba(47,120,255,0.1);color: #2F78FF;}
				}
			}
		}
	}
	.list{display: flex;align-items: center;flex-wrap: wrap;margin-top: 30px;margin-bottom: 22px;
		.item{width: 224px;height: 290px;background: #FFFFFF;border-radius: 8px;margin-right: 20px;margin-bottom: 20px;cursor: pointer;
			&:nth-child(5n+5){margin-right: 0;}
			.img{height: 208px;background: #D9D9D9;border-radius: 8px;overflow: hidden;
				img{width: 100%;height: 100%;transition: all .6s;}
			}
			.txt{padding: 12px 8px;
				h3{color: #1F263F;font-size: 16px;font-weight: bold;margin-bottom: 6px;transition: all .3s;}
				p{color: #A4A9B7;font-size: 12px;}
			}
			&:hover{
				img{transform: scale(1.2);}
				h3{color: #2F78FF;}
			}
		}

	}
	.pageBox{display: flex;align-items: center;justify-content: space-around;margin-bottom: 30px;}
}
</style>


// WEBPACK FOOTER //
// src/views/server/index.vue